import React from 'react';


class Spinner extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'Spinner';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const className = 'component-spinner';

    return (
      <div className={className}>
        <div className='spinner' />
      </div>
    );
  }
}


export default Spinner;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/Spinner.jsx
 **/